import secureLocalStorage from "react-secure-storage";
import APICaller from "./APICaller";
import moment from "moment";

const HandleSearch = async (
  hasSearchedValue,
  searchIn,
  searchKeyword,
  callActionFrom,
  globalStates = {},
  allStates = {},
  listing = "",
) => {
  // ----------------------------
  // SAFE DESTRUCTURING
  // ----------------------------

  const { globalState = {}, setGlobalState } = globalStates || {};
  const {
    setShowLoader,
    pagination = {},
    setAllTransactionIdsArr,
    setList,
    setListItems,
    tab,
  } = allStates || {};

  // ----------------------------
  // SAFE NO-OP FUNCTIONS
  // ----------------------------
  const noop = () => {};

  const safeSetGlobalState =
    typeof setGlobalState === "function" ? setGlobalState : noop;
  const safeSetShowLoader =
    typeof setShowLoader === "function" ? setShowLoader : noop;
  const safeSetList = typeof setList === "function" ? setList : noop;
  const safeSetListItems =
    typeof setListItems === "function" ? setListItems : noop;
  const safeSetAllTransactionIdsArr =
    typeof setAllTransactionIdsArr === "function"
      ? setAllTransactionIdsArr
      : noop;

  // ----------------------------
  // PAGINATION
  // ----------------------------
  const { current = 1, page = 1, pageSize = 50 } = pagination;
  const pge = current || page;

  // ----------------------------
  // API PARAMS
  // ----------------------------
  const role = secureLocalStorage.getItem("role");
  const accessToken = secureLocalStorage.getItem("accessToken");
  const lIUId = secureLocalStorage.getItem("lIUId");
  const action = "findAll";
  const auditType = secureLocalStorage.getItem("auditType");

  // Clear search data if the input is empty
  const searchKeywordOnRefresh = document.querySelector(".inputS");

  if (!searchKeywordOnRefresh?.value) {
    if (secureLocalStorage.getItem("hasSearchedValue")) {
      secureLocalStorage.removeItem("hasSearchedValue");
    }
    if (secureLocalStorage.getItem("searchKeyword")) {
      secureLocalStorage.removeItem("searchKeyword");
    }
  }

  const body = {
    page: pge,
    pageSize,
    role,
    lIUId,
    searchIn,
    searchKeyword:
      searchKeyword || secureLocalStorage.getItem("searchKeyword") || "",
    tab,
    listing,
  };

  if (searchIn === "audits") {
    body.auditType = auditType || "ops";
  }
  // Call the API and get records
  const allRecs = await APICaller(
    role,
    accessToken,
    `/${searchIn}/${action}`,
    "POST",
    body,
  );

  // Process the response based on the searchIn type
  const {
    response = {},
    totalCount = 0,
    sent = 0,
    reverted = 0,
  } = allRecs || {};

  if (!response) {
    safeSetShowLoader(false);
    return { data: [], totalCount: 0 };
  }

  switch (searchIn) {
    case "auditForms": {
      const temp = response.map((dataList, index) => ({
        key: dataList._id,
        id: index + 1,
        form_name: dataList.formName,
        total_audits: dataList.totalAudits,
        active_audits: dataList.activeAudits,
        hasWeightage: dataList.hasWeightage,
        status: dataList.status || "",
        createdAt: dataList.createdAt
          ? moment(dataList.createdAt).format("DD-MM-YY HH:mm A")
          : "",
        updatedAt: dataList.updatedAt
          ? moment(dataList.updatedAt).format("DD-MM-YY HH:mm A")
          : "",
      }));
      safeSetList(temp);
      safeSetListItems(totalCount);
      safeSetGlobalState((prev) => ({
        ...prev,
        list: temp,
        recordCountFor: "auditForms",
        recordCount: totalCount,
        selectedRowKeysChildInfo: [],
        searchResult: "empty",
        pagination: {
          ...pagination,
          page: pge,
          pageSize: pageSize,
          total: totalCount,
        },
      }));
      safeSetShowLoader(false);

      return {
        data: temp,
        totalCount,
      };
    }
    case "audits": {
      const temp = [];
      let allTransactionIdsArr = [];
      response?.map((audit, index) => {
        // Initialize the object with both key and value properties
        const objectToAdd = {
          key: index + 1,
          id: audit?._id,
          processId: audit?.process?._id,
          transaction_id: audit?.transaction_id,
          agent: audit?.agent,
          auditor: audit?.auditor,
          supervisor: audit?.agentReportingSupervisor?.name
            ? audit?.agentReportingSupervisor?.name
            : audit?.agentAtl?.name,
          createdAt: audit?.createdAt,
          transaction_date: audit?.transactionDate,
          auditBackDateReason: audit?.auditBackDateReason,
          form: audit?.auditForm?.formName,
          formId: audit?.auditForm?._id, 
          auditFor: audit?.auditFor,
          stage: audit?.stage,
          score: JSON.parse(audit?.auditedScoreInfo)?.score,
          active: audit?.status,
          comments: audit?.comment,
          hasWeightage: audit?.hasWeightage,
          formMethd: "update",
        };
        temp.push(objectToAdd);

        if (audit?.transaction_id) {
          allTransactionIdsArr.push(audit?.transaction_id);
        }
      });

      safeSetList(temp);
      safeSetListItems(totalCount);

      safeSetGlobalState((prev) => ({
        ...prev,
        list: temp,
        recordCountFor: "audits",
        recordCount: totalCount,
        auditLists: allRecs,
        exportAuditReportJson: "[{}]",
        selectedRowKeysChildInfo: [],
        searchResult: "empty",
        pagination: {
          ...pagination,
          page: pge,
          pageSize: pageSize,
          total: totalCount,
        },
      }));
      safeSetShowLoader(false);
      return {
        data: temp,
        totalCount,
        meta: {
          allTransactionIdsArr,
          auditLists: allRecs,
        },
      };
    }
    case "deleted-audits": {
      const temp = [];

      let allTransactionIdsArr = [];
      response?.map((deletedAudit, index) => {
        // Initialize the object with both key and value properties
        const objectToAdd = {
          key: index + 1,
          id: deletedAudit?._id,
          transaction_id: deletedAudit?.transaction_id,
          agent: deletedAudit?.agent,
          auditor: deletedAudit?.auditor,
          supervisor: deletedAudit?.agentReportingSupervisor?.name
            ? deletedAudit?.agentReportingSupervisor?.name
            : deletedAudit?.agentAtl?.name,
          createdAt: deletedAudit?.createdAt,
          transaction_date: deletedAudit?.transactionDate,
          auditBackDateReason: deletedAudit?.auditBackDateReason,
          auditDeleteReason: deletedAudit?.auditDeleteReason,
          form: deletedAudit?.auditForm?.formName,
          formId: deletedAudit?.auditForm?._id,
          stage: deletedAudit?.stage,
          score: JSON.parse(deletedAudit?.auditedScoreInfo)?.score,
          active: deletedAudit?.status,
          comments: deletedAudit?.comment,
          hasWeightage: deletedAudit?.hasWeightage,
          formMethd: "update",
        };
        temp.push(objectToAdd);

        if (deletedAudit?.transaction_id) {
          allTransactionIdsArr.push(deletedAudit?.transaction_id);
        }
      });

      safeSetList(temp);
      safeSetListItems(totalCount);

      safeSetGlobalState((prev) => ({
        ...prev,
        list: temp,
        recordCountFor: "deleted-audits",
        recordCount: totalCount,
        deletedAuditLists: allRecs,
        exportAuditReportJson: "[{}]",
        selectedRowKeysChildInfo: [],
        searchResult: "empty",
        pagination: {
          ...pagination,
          page: pge,
          pageSize: pageSize,
          total: totalCount,
        },
      }));
      safeSetShowLoader(false);

      return {
        data: temp,
        totalCount,
        meta: {
          allTransactionIdsArr,
          deletedAuditLists: allRecs,
        },
      };
    }
    case "client-escalation": {
      const temp = [];

      let allTransactionIdsArr = [];
      response?.map((dataList, index) => {
        // Initialize the object with both key and value properties
        const objectToAdd = {
          key: index + 1,

          id: dataList?._id,
          empID: dataList?.empID,
          financialImpact: dataList?.financialImpact,
          agent: dataList?.agent,
          auditor: dataList?.auditor,
          reportingTl: dataList?.reportingTl,
          errorImpact: dataList?.errorImpact,
          transaction: dataList?.transactionId,
          transactionDuplicateReason: dataList?.transactionDuplicateReason,
          department: dataList?.department,
          client: dataList?.client,
          errorArea: dataList?.errorArea,
          errorType: dataList?.errorType,
          rcaLevelOne: dataList?.rcaLevelOne,
          rcaLevelTwo: dataList?.rcaLevelTwo,
          rcaLevelThree: dataList?.rcaLevelThree,
          rcaLevelFour: dataList?.rcaLevelFour,
          stage: dataList?.stage,
          status: dataList.status || "",
          errorRaiseDate: moment(dataList?.errorRaiseDate).format(
            "DD/MM/YYYY H:mm A",
          ),
        };

        temp.push(objectToAdd);
        if (dataList?.transactionId) {
          allTransactionIdsArr.push(dataList?.transactionId);
        }
      });

      safeSetList(temp);
      safeSetListItems(totalCount);
      safeSetGlobalState((prev) => ({
        ...prev,
        clientEslist: temp,
        clientEscalationLists: temp,
        recordCountFor: "client-escalations",
        recordCount: totalCount,
        exportClientEscalationReportJson: "[{}]",
        selectedRowKeysChildInfo: [],
        searchResult: "empty",
        pagination: {
          ...pagination,
          page: pge,
          pageSize: pageSize,
          total: totalCount,
        },
      }));

      safeSetShowLoader(false);

      return {
        data: temp,
        totalCount,
        meta: {
          allTransactionIdsArr,
          clientEscalationLists: allRecs,
        },
      };
    }
    case "internal-error-rca": {
      const temp = [];
      let allTransactionIdsArr = [];

      response?.map((dataList, index) => {
        // Initialize the object with both key and value properties
        const objectToAdd = {
          key: index + 1,
          id: dataList?._id,
          internalerrorrcaID: dataList?.internalerrorrcaID,
          processId: dataList?.process?._id,
          transaction_id: dataList?.transaction_id,
          agent: dataList?.agent,
          auditor: dataList?.auditor,
          supervisor: dataList?.agentReportingSupervisor?.name
            ? dataList?.agentReportingSupervisor?.name
            : dataList?.agentAtl?.name,
          createdAt: moment(dataList.createdAt).format("DD-MM-YY HH:mm A"),
          transaction_date: dataList?.transactionDate,
          auditBackDateReason: dataList?.auditBackDateReason,
          form: dataList?.auditForm?.formName,
          formId: dataList?.auditForm?._id,
          stage: dataList?.stage,
          score: JSON.parse(dataList?.auditedScoreInfo)?.score,
          active: dataList?.status,
          comments: dataList?.comment,
          hasWeightage: dataList?.hasWeightage,
          formMethd: "update",
        };
        temp.push(objectToAdd);

        if (dataList?.transactionId) {
          allTransactionIdsArr.push(dataList?.transaction_id);
        }
      });

      safeSetList(temp);
      safeSetListItems(totalCount);
      safeSetGlobalState((prev) => ({
        ...prev,
        list: temp,
        recordCountFor: "internal-error-rca",
        recordCount: totalCount,
        internalErrorRcaLists: allRecs,
        exportInternalErrorRcaReportJson: "[{}]",
        selectedRowKeysChildInfo: [],
        searchResult: "empty",
        pagination: {
          ...pagination,
          page: pge,
          pageSize: pageSize,
          total: totalCount,
        },
      }));
      safeSetShowLoader(false);

      return {
        data: temp,
        totalCount,
        meta: {
          allTransactionIdsArr,
          internalErrorRcaLists: allRecs,
        },
      };
    }
    case "processes": {
      const temp = response.map((dataList, index) => ({
        key: dataList._id,
        id: index + 1,
        name: dataList.name,
        department: dataList.department ? dataList.department.name : "",
        status: dataList.status || "",
        createdAt: dataList.createdAt
          ? moment(dataList.createdAt).format("DD-MM-YY HH:mm A")
          : "",
        updatedAt: dataList.updatedAt
          ? moment(dataList.updatedAt).format("DD-MM-YY HH:mm A")
          : "",
      }));
      safeSetList(temp);
      safeSetListItems(totalCount);
      safeSetGlobalState({
        ...globalState,
        list: temp,
        recordCountFor: "processes",
        recordCount: totalCount,
        pagination: {
          ...pagination,
          page: pge,
          pageSize: pageSize,
          total: totalCount,
        },
      });
      safeSetShowLoader(false);

      return {
        data: temp,
        totalCount,
      };
    }
    case "clients": {
      const temp = response.map((dataList, index) => ({
        key: dataList._id,
        id: index + 1,
        name: dataList.name,
        status: dataList.status || "",

        // for form edit
        departments: dataList.departments?.map((dept) => dept._id) || [],

        // for table display
        departmentsLabel:
          dataList.departments?.map((dept) => dept.name).join(", ") || "",

        createdAt: dataList.createdAt
          ? moment(dataList.createdAt).format("DD-MM-YY HH:mm A")
          : "",
        updatedAt: dataList.updatedAt
          ? moment(dataList.updatedAt).format("DD-MM-YY HH:mm A")
          : "",
      }));
      
      safeSetList(temp);
      safeSetListItems(totalCount);
      safeSetGlobalState({
        ...globalState,
        list: temp,
        recordCountFor: "clients",
        recordCount: totalCount,
        pagination: {
          ...pagination,
          page: pge,
          pageSize: pageSize,
          total: totalCount,
        },
      });
      safeSetShowLoader(false);

      return {
        data: temp,
        totalCount,
      };
    }
    case "departments": {
      const temp = response.map((dataList, index) => ({
        key: dataList._id,
        id: index + 1,
        name: dataList.name,
        status: dataList.status || "",
        createdAt: dataList.createdAt
          ? moment(dataList.createdAt).format("DD-MM-YY HH:mm A")
          : "",
        updatedAt: dataList.updatedAt
          ? moment(dataList.updatedAt).format("DD-MM-YY HH:mm A")
          : "",
      }));
      safeSetList(temp);
      safeSetListItems(totalCount);
      safeSetGlobalState({
        ...globalState,
        list: temp,
        recordCountFor: "departments",
        recordCount: totalCount,
        pagination: {
          ...pagination,
          page: pge,
          pageSize: pageSize,
          total: totalCount,
        },
      });
      safeSetShowLoader(false);
      return {
        data: temp,
        totalCount,
      };
    }

    //VOC
    case "sendForms": {
      const temp = response.map((dataList, index) => ({
        key: dataList?._id,
        id: dataList?._id,
        formDisplayName: dataList?.formName?.formDisplayName,
        recipient: dataList?.recipients.toString(),
        status: dataList?.status,
        created_at:
          dataList.createdAt &&
          moment.utc(dataList.createdAt).format("DD-MM-YY HH:mm A"),
        updated_at:
          dataList.updatedAt &&
          moment(dataList.updatedAt).format("DD-MM-YY HH:mm A"),
      }));

      safeSetList(temp);
      safeSetListItems(totalCount);
      safeSetGlobalState((prev) => ({
        ...prev,
        list: temp,
        formLists: allRecs,
        recordCountFor: "sendForms",
        recordCount: totalCount,
        exportFormsJson: "[{}]",
        selectedRowKeysChildInfo: [],
        searchResult: "empty",
        pagination: {
          ...pagination,
          page: pge,
          pageSize: pageSize,
          total: totalCount,
        },
      }));

      safeSetShowLoader(false);

      return {
        data: temp,
        totalCount,
      };
    }
    case "feedback-requests": {
      const temp = response.map((dataList, index) => ({
        key: dataList?._id,
        id: dataList?._id,
        formType: dataList?.form?.formType,
        recipient: dataList?.recipient,
        status: dataList?.status,
        createdAt:
          dataList.createdAt &&
          moment.utc(dataList.createdAt).format("DD-MM-YY HH:mm A"),
        capturedOn:
          dataList.capturedOn &&
          moment(dataList.capturedOn).format("DD-MM-YY HH:mm A"),
        feedBackLink: process.env.REACT_APP_URI + "/survey/" + dataList?._id,
        previewBy: dataList?.status === "CLOSED" ? dataList?._id : "",
      }));
      safeSetList(temp);
      safeSetListItems(totalCount);
      safeSetGlobalState((prev) => ({
        ...prev,
        list: temp,
        sent: sent,
        reverted: reverted,
        notReverted: sent && reverted >= 0 ? sent - reverted : 0,
        feedbackRequestLists: allRecs,
        recordCountFor: "feedback-requests",
        recordCount: totalCount,
        exportFeedbackRequestsJson: "[{}]",
        selectedRowKeysChildInfo: [],
        searchResult: "empty",
        pagination: {
          ...pagination,
          page: pge,
          pageSize: pageSize,
          total: totalCount,
        },
      }));

      safeSetShowLoader(false);

      return {
        data: temp,
        totalCount,
        meta: {
          sent: sent,
          reverted: reverted,
          notReverted: sent && reverted >= 0 ? sent - reverted : 0,
          feedbackRequestLists: allRecs,
        },
      };
    }

    //Manage Permissions
    case "permissions": {
      const temp = response.map((dataList, index) => ({
        key: dataList._id,
        id: index + 1,
        name: dataList.name,
        permissionType: dataList.permissionType,
        status: dataList.status || "",
        createdAt: dataList.createdAt
          ? moment(dataList.createdAt).format("DD-MM-YY HH:mm A")
          : "",
        updatedAt: dataList.updatedAt
          ? moment(dataList.updatedAt).format("DD-MM-YY HH:mm A")
          : "",
      }));
      safeSetList(temp);
      safeSetListItems(totalCount);
      safeSetGlobalState((prev) => ({
        ...prev,
        list: temp,
        recordCountFor: "permissions",
        recordCount: totalCount,
        pagination: {
          ...pagination,
          page: pge,
          pageSize: pageSize,
          total: totalCount,
        },
      }));

      safeSetShowLoader(false);

      return {
        data: temp,
        totalCount,
      };
    }
    case "sections": {
      const temp = response.map((dataList, index) => ({
        key: dataList._id,
        id: index + 1,
        name: dataList.name,
        icon: dataList.icon,
        parentSection: dataList.parentSection?.name,
        permissions: dataList.permissions,
        position: dataList.position,
        status: dataList.status || "",
        createdAt: dataList.createdAt
          ? moment(dataList.createdAt).format("DD-MM-YY HH:mm A")
          : "",
        updatedAt: dataList.updatedAt
          ? moment(dataList.updatedAt).format("DD-MM-YY HH:mm A")
          : "",
      }));

      safeSetList(temp);
      safeSetListItems(totalCount);
      safeSetGlobalState((prev) => ({
        ...prev,
        list: temp,
        recordCountFor: "sections",
        recordCount: totalCount,
        pagination: {
          ...pagination,
          page: pge,
          pageSize: pageSize,
          total: totalCount,
        },
      }));

      safeSetShowLoader(false);

      return {
        data: temp,
        totalCount,
      };
    }
    case "roles": {
      const temp = response.map((dataList, index) => ({
        key: dataList._id,
        id: index + 1,
        name: dataList.name,
        sections: dataList?.sections,
        status: dataList.status || "",
        createdAt: dataList.createdAt
          ? moment(dataList.createdAt).format("DD-MM-YY HH:mm A")
          : "",
        updatedAt: dataList.updatedAt
          ? moment(dataList.updatedAt).format("DD-MM-YY HH:mm A")
          : "",
      }));
      safeSetList(temp);
      safeSetListItems(totalCount);
      safeSetGlobalState((prev) => ({
        ...prev,
        list: temp,
        recordCountFor: "roles",
        recordCount: totalCount,
        pagination: {
          ...pagination,
          page: pge,
          pageSize: pageSize,
          total: totalCount,
        },
      }));

      safeSetShowLoader(false);

      return {
        data: temp,
        totalCount,
      };
    }
    case "users": {
      const temp = response.map((dataList, index) => {
      

        return {
          key: dataList._id,
          id: index + 1,
          empID: dataList.empID,
          name: dataList.name,
          email: dataList.email,
          role: dataList.role,
          vp: dataList.vp || "",
          avp: dataList.avp || "",
          manager: dataList.manager || "",
          am: dataList.am || "",

          tl: dataList.tl || "",

          atl: dataList.atl || "",

          client: Array.isArray(dataList.client) ? dataList.client : [],
          clientScope: dataList.clientScope || "LIMITED",
          department: Array.isArray(dataList.department)
            ? dataList.department
            : [],

          departmentScope: dataList.departmentScope || "LIMITED",

          additionalPermissions: dataList.additionalPermissions || [],
          profilePicUrl: dataList.profilePicUrl || "",
          status: dataList.status || "",
          createdAt: dataList.createdAt
            ? moment(dataList.createdAt).format("DD-MM-YY HH:mm A")
            : "",
          updatedAt: dataList.updatedAt
            ? moment(dataList.updatedAt).format("DD-MM-YY HH:mm A")
            : "",
        };
      });
      //secureLocalStorage.setItem("searchData", temp);

      safeSetList(temp);
      safeSetListItems(totalCount);
      safeSetGlobalState((prev) => ({
        ...prev,
        list: temp,
        recordCountFor: "users",
        recordCount: totalCount,
        pagination: {
          ...pagination,
          page: pge,
          pageSize: pageSize,
          total: totalCount,
        },
      }));

      safeSetShowLoader(false);

      return {
        data: temp,
        totalCount,
      };
    }
    default: {
      safeSetGlobalState({
        ...globalState,
        list: [],
      });

      safeSetShowLoader(false);

      // Redux-safe return
      return {
        data: [],
        totalCount: 0,
      };
    }
  }
};

export default HandleSearch;
